















































































































import Vue from "vue";
import { State, Action, Getter } from "vuex-class";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import { Utilities as utils } from "@/shared/utilities";
import { AppConstants as _app } from "@/shared/app.constants";

const namespace: string = "RootApp";

@Component({
  components: {},
})
export default class UsefulDocListComponent extends Vue {
  @Action("_appAbout", { namespace }) _appAbout: any;
  search='';
  items = [];
  get headers() {
    _app.usefulDocHeaders.map((x) => {
      x.text = this.$t(x.text);
    });
    return _app.usefulDocHeaders
  }
  mounted() {
    this.$services.usefulDocs
      .GetForPublic()
      .then((data) => {
        if (data.Result == "OK") {
          this.items = data.Record
          console.log(this.items)
        } else {
        }
      })
      .catch((err) => {

        });
  }
}
